import React from "react";
import { Box } from "@mui/material";
import { C } from "../../common/theme";

/** An email's HTML in a sandboxed frame: no scripts, no access to the
 * dashboard, links open in a new tab. Emails are designed on white, so the
 * frame stays white. On phones it fills most of the screen; the email scrolls
 * inside it. */
export default function EmailPreview({ html, title }: { html: string; title: string }) {
  const doc = React.useMemo(() => {
    const base = '<base target="_blank">';
    return /<head[^>]*>/i.test(html) ? html.replace(/<head([^>]*)>/i, `<head$1>${base}`) : `${base}${html}`;
  }, [html]);
  return (
    <Box
      component="iframe"
      title={title}
      srcDoc={doc}
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="no-referrer"
      sx={{
        display: "block",
        width: "100%",
        height: { xs: "min(70vh, 640px)", md: 600 },
        minHeight: 360,
        border: `1px solid ${C.line}`,
        borderRadius: "8px",
        bgcolor: C.paper,
        boxSizing: "border-box",
      }}
    />
  );
}
